"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.run = void 0;
const core = require("@actions/core");
const exec = require("@actions/exec");
const io = require("@actions/io");
function run() {
    return __awaiter(this, void 0, void 0, function* () {
        const imageToPush = core.getInput('image-to-push');
        const quayRegistry = core.getInput('quay-registry');
        const username = core.getInput('username');
        const password = core.getInput('password');
        // get podman cli
        const podman = yield io.which('podman', true);
        // push image
        const push = yield execute(podman, ['push', '--creds', `${username}:${password}`, `${imageToPush}`, `${quayRegistry}`]);
        if (push.succeeded === false) {
            return Promise.reject(new Error(push.reason));
        }
    });
}
exports.run = run;
function execute(executable, args) {
    return __awaiter(this, void 0, void 0, function* () {
        let error = '';
        const options = {};
        options.listeners = {
            stderr: (data) => {
                error += data.toString();
            }
        };
        const exitCode = yield exec.exec(this.executable, args, options);
        if (exitCode === 1) {
            return Promise.resolve({ succeeded: false, error: error });
        }
        return Promise.resolve({ succeeded: true });
    });
}
run().catch(core.setFailed);
